export default "__VITE_ASSET__0de3ef4b__"